import { useTheme } from '@mui/material';
import { AppLocationContext, Breadcrumb } from '@react-admin/ra-navigation';
import { useTranslate } from 'react-admin';
import { useLocation } from 'react-router-dom';

import { GetB2bAdminsIdEndpoint } from '@Common/types/bo/b2b/admins';
import { GetB2bEmployeeDocumentDetailsEndpoint } from '@Common/types/bo/b2b/employees';
import { GetCompanyResponse } from '@Common/types/bo_external/companies';

import { buildLink } from '@sh4res/bo-common/utils/build_link';

export const AppBreadcrumb = () => {
  const theme = useTheme();
  const translate = useTranslate();

  const location = useLocation();

  const isCompaniesShow = location.pathname.includes('/companies');
  const isAdminsShow = location.pathname.includes('/admins');

  return (
    <AppLocationContext>
      <Breadcrumb
        sx={{
          position: 'sticky',
          top: 0,
          backgroundColor: theme.palette.background.default,
        }}
        role="navigation">
        {!isCompaniesShow && !isAdminsShow && <Breadcrumb.ResourceItems />}

        <Breadcrumb.Item
          name="companies"
          label={translate('menu.companies')}
          to={buildLink('companies', 'list')}>
          <Breadcrumb.Item
            name="show"
            label={({ record }: { record?: GetCompanyResponse }) => record?.name ?? ''}
          />
        </Breadcrumb.Item>

        <Breadcrumb.Item
          name="admins"
          label={translate('resources.companies.tabs.admins.label')}
          to={({ record }: { record?: GetB2bAdminsIdEndpoint['Client']['ResponseBody'] }) =>
            `/companies/${record?.id}/show?tab=admins`
          }>
          <Breadcrumb.Item
            name="show"
            label={({ record }: { record?: GetB2bAdminsIdEndpoint['Client']['ResponseBody'] }) =>
              `${record?.firstname} ${record?.lastname}`
            }
          />
        </Breadcrumb.Item>

        <Breadcrumb.Item
          name="companies/documents"
          label={translate('resources.companies.tabs.documents.label')}
          to={({
            record,
          }: {
            record?: GetB2bEmployeeDocumentDetailsEndpoint['Client']['ResponseBody'];
          }) => `/companies/${record?.id}/show?tab=documents`}>
          <Breadcrumb.Item
            name="show"
            label={({
              record,
            }: {
              record?: GetB2bEmployeeDocumentDetailsEndpoint['Client']['ResponseBody'];
            }) => record?.document_name ?? ''}
          />
        </Breadcrumb.Item>

        <Breadcrumb.Item name="contact_support" label={translate('contact_support_page.title')} />
      </Breadcrumb>
    </AppLocationContext>
  );
};
